import { useShowMore } from '@space-core/hooks'
import useTranslation from '@space-core/hooks/useTranslation'
import { focusVisible } from '@space-core/styles'
import styled from 'styled-components'

export type DescriptionProps = {
  description: string
  isMobile: boolean
}

const MIN_CHARACTERS_MOBILE = 68
const MIN_CHARACTERS_DESKTOP = 262

const Text = styled.p`
  color: var(--gray-600) !important;
  font-size: var(--text-2);
  line-break: anywhere;
`

const ButtonShowMore = styled.button`
  color: var(--gray-600) !important;
  background-color: Transparent;
  background-repeat: no-repeat;
  border: none;
  text-decoration: underline;
  ${focusVisible}
`

const Description = ({ description, isMobile }: DescriptionProps) => {
  const { t } = useTranslation()
  const { isShowMore, showMore, showLess } = useShowMore()
  const characters = isMobile ? MIN_CHARACTERS_MOBILE : MIN_CHARACTERS_DESKTOP

  const handleClickShow = () => (isShowMore ? showLess() : showMore())

  const expandText = isShowMore
    ? t('bundle.description_show_less')
    : t('bundle.description_show_more')

  return (
    <Text data-test='text-description'>
      {isShowMore ? description : `${description.substring(0, characters)}`}
      {description.length > characters && (
        <ButtonShowMore
          className='_cursor-pointer'
          data-test='button-show-more'
          onClick={handleClickShow}>
          <span className='_font-weight-bold'>{expandText}</span>
        </ButtonShowMore>
      )}
    </Text>
  )
}

export default Description
